import React from 'react'

const HeaderLogo = () => (
  <a className="c-header-logo" href="https://theblacktux.com">
    <span className="u-sr-only">Go Home</span>
    <svg className="c-header-logo__wordmark c-header-logo__wordmark">
      <use xlinkHref="#icon-tbt-logo" />
    </svg>
  </a>
)

export default HeaderLogo
